import { memo } from "react";

function CourseDetails({ course, completed, total }) {
  if (!course) return null;
  const { title, description, progress = 0 } = course;

  return (
    <div className="w-full bg-white border-b flex flex-col">
      <div className="px-4 py-3 flex-1 overflow-auto">
        <h1 className="text-lg sm:text-lg font-semibold text-green-600">
          {title}
        </h1>
        <p className="text-gray-600 mt-2 text-sm sm:text-base max-w-3xl">
          {description}
        </p>

        {/* Progress Section */}
        <div className="mt-4 max-w-3xl">
          <div className="flex justify-between items-center text-sm text-gray-600 mb-2">
            <span>
              {completed} of {total} modules completed
            </span>
            <span className="font-medium text-gray-900">{progress}%</span>
          </div>

          <div className="w-full h-2 bg-gray-200 rounded overflow-hidden">
            <div
              className="h-full bg-green-700 rounded transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(CourseDetails);
